/**
 * Generate a new router route using params and keeping the search and hash from current location
 * @param path
 * @param params
 * @param search
 * @param hash
 * @returns
 */
export const getRoute = (
  path: string,
  params: Record<string, string | undefined | null> = {},
  search?: string,
  hash?: string
) => {
  for (const key in params) {
    path = path.replace(`:${key}`, params[key] || "-");
  }
  search = search || document.location.search.slice(1);
  hash = hash || document.location.hash.slice(1);
  return path + (search ? `?${search}` : "") + (hash ? `#${hash}` : "");
};

const prefix = "/pass";
const prefixWallet = "/pass/wallet";
const prefixLog = "/sign-in";
const prefixForce = "/force";

export const OlkyPassRoutes = {
  reset_password: prefixLog + "/reset-password",
  force_webauthn: prefixForce + "/webauthn",

  pass: prefix,
  dashboard: prefix + "/dashboard",
  dashboard_partner: prefix + "/dashboard/:partner",
  account_transactions: prefix + "/transactions",
  support: prefix + "/support",
  kycoin: prefix + "/kycoin",
  kypay: prefix + "/kypay",
  kypayOnChain: prefix + "/on-chain",
  account_base: prefix + "/account",
  account_identity: prefix + "/account/identity",
  security: prefix + "/security",
  account_alias_email: prefix + "/account/alias/email",
  level: prefix + "/account/level",
  account_alias_mobile: prefix + "/account/alias/mobile",
  account_alias_address: prefix + "/account/alias/address",
  account_alias_documents: prefix + "/account/alias/documents",
  account_alias_public: prefix + "/account/alias/public",
  account_alias_payments: prefix + "/account/alias/payments",

  // Wallet
  wallet_base: prefixWallet,
  wallet_dashboard: prefixWallet + "/dashboard",
  wallet_form: prefixWallet + "/form",
  wallet_buy: prefixWallet + "/buy",
  wallet_sell: prefixWallet + "/sell",
  wallet_convert: prefixWallet + "/convert",
  wallet_transfer: prefixWallet + "/transfer",
  wallet_crypto: prefixWallet + "/crypto/list",
  wallet_crypto_details: prefixWallet + "/crypto/:cryptoKey",
  // Flow uses another prefix
  flow: "/flow",
  flow_session: "/flow/:session_uuid",
  flow_block: "/flow/:session_uuid/:block",
  flow_step: "/flow/:session_uuid/:block/:step",
  flow_substep: "/flow/:session_uuid/:block/:step/:substep",
  //company Routes
  companies: prefix + "/company",
  company_onboarding: prefix + "/company/:company/onboarding",
  company_related_person: prefix + "/company/:company/related_person",
  company_olkypass_pro_payment: prefix + "/company/:company/payments",
  dashboard_company: prefix + "/dashboard/:company",
  level_company: prefix + "/account/level/:company",
  account_alias_mobile_company: prefix + "/account/alias/mobile/:company",
  account_alias_address_company: prefix + "/account/alias/address/:company",
  account_alias_documents_company: prefix + "/account/alias/documents/:company",
  account_alias_public_company: prefix + "/account/alias/public/:company",
  account_alias_payments_company: prefix + "/account/alias/payments/:company",
  account_alias_email_company: prefix + "/account/alias/email/:company",
  account_transactions_company: prefix + "/transactions/:company",

  // company partner
  dashboard_company_partner: prefix + "/dashboard/:company/:partner",

  document_consent: prefix + "/consent"
};
